export interface EnrichedSupplierItem {
  supplierName: string;
  supplierId: string;
  distanceKm: number;
  coverage: number;
  label: string;
  count: number;
  isPartial?: boolean;
  isRefined?: boolean;
  isAssociated?: boolean;
  fulfilledCount?: number;
  fulfilledPercent: number;
  totalParts?: number;
  totalPartPercentage: number;
  supplierCity?: string;
}

export enum SupplierDiscoverySortOptions {
  DISTANCE = "distance",
  AVAILABILITY = "",
  FULFILLEDPERCENTAGE = "fulfilledPercentage",
  TOTALPARTSPERCENTAGE = "totalPartsPercentage",
}

export enum BucketType {
  IN_PROGRESS = "inProgress",
  SAVED = "saved",
}

export interface SupplierPartAvailabilityResultDto {
  supplierId: string;
  rootPartNumber: string;
  familyQuantity: number;
  updatedAt?: string;
}

export interface SupplierPartAvailabilityResponseDto {
  requestId: string;
  results: SupplierPartAvailabilityResultDto[];
}

export interface SupplierInventoryDeltaResultDto {
  supplierId: string;
  rootPartNumber: string;
  deltaQuantity: number;
}

export interface SupplierInventoryDeltaResponseDto {
  results: SupplierInventoryDeltaResultDto[];
}

export interface OfflineSupplierEntry {
  supplierId: string;
  supplierName: string;
  coords: string;
  groupKey: string;
  parts: Array<{ rootPartNumber: string; familyQuantity: number; source?: string }>;
  updatedAt?: string;
}
